/**
 * Retrieves campaign cookie information based on URL query parameters.
 *
 * @returns {Object} An object containing campaign-related cookie data, including validity, name, value, and options.
 *                   Returns default invalid state if 'utm_campaign' is not found in the URL.
 */
const getCampaignCookieInfo = () => {
    const res = {
        is_valid: false,
        name: null,
        value: null,
        options: null
    }

    if (window.location.search.match(/utm_campaign/i) == null) return res

    let d = new Date()
    d.setTime(d.getTime() + 60 * 24 * 60 * 60 * 1000)

    const domain = window.location.host.replace(/^(www|app|app\w+)\./i, '.')
    const value = JSON.stringify(window.location.search)

    res.is_valid = true
    res.name = 'cmpmrf'
    res.value = value
    res.options = { path: '/', expires: d, domain: domain }

    return res
}

/**
 * Object containing a reference to the function `getCampaignCookieInfo`.
 *
 * @constant {Object} payload - Object used to export the `getCampaignCookieInfo` function.
 */
const payload = {
    getCampaignCookieInfo
}

export default payload
